/* eslint-disable default-param-last */
import {
  EAttributeType,
  EAttributeUnitFamily, IAttributeDefaults, IAttributeLocalization, IAttributeValidation
} from '../../@types/AttributeTypes';


export interface IAttribute {
  readonly id: number;
  readonly key: string;
  readonly predecessorId: number | null;
  readonly type: EAttributeType;
  unit: string | null;
  readonly hidden: boolean;
  readonly forced: boolean;
  value?: string | number;

  readonly ownerId?: number;
  readonly userId?: number;
  readonly publicFlag?: boolean;
  
  readonly unitFamily?: EAttributeUnitFamily;
  readonly localization?: IAttributeLocalization;
  readonly defaults?: IAttributeDefaults;
  readonly validation?: IAttributeValidation;
}

export class AttributeModel implements IAttribute {
  readonly id: number;
  readonly key: string;
  readonly predecessorId: number | null;
  readonly type: EAttributeType;
  unit: string | null;
  readonly hidden: boolean;
  readonly forced: boolean;
  value?: string | number;

  readonly ownerId?: number;
  readonly userId?: number;
  readonly publicFlag?: boolean;
  readonly unitFamily?: EAttributeUnitFamily;
  readonly localization?: IAttributeLocalization;
  readonly defaults?: IAttributeDefaults;
  readonly validation?: IAttributeValidation;

  constructor(
    id: number,
    key: string = '',
    value?: string | number,
    predecessorId: number | null = null,
    type: EAttributeType = EAttributeType.TEXT,
    unit: string | null = null,
    hidden: boolean = false,
    forced: boolean = false,
    ownerId?: number,
    userId?: number,
    publicFlag?: boolean,
    localization?: IAttributeLocalization,
    defaults?: IAttributeDefaults,
    validation?: IAttributeValidation,
    unitFamily: EAttributeUnitFamily = EAttributeUnitFamily.NONE
  ) {
    this.id = id;
    this.key = key;
    this.value = value;
    this.predecessorId = predecessorId;
    this.type = type;
    this.unit = unit;
    this.hidden = hidden;
    this.forced = forced;

    this.ownerId = ownerId;
    this.userId = userId;
    this.publicFlag = publicFlag;
    this.localization = localization;
    this.defaults = defaults;
    this.validation = validation;
    this.unitFamily = unitFamily;
  }

  toJSON() {
    return {
      id: this.id,
      key: this.key,
      predecessorId: this.predecessorId,
      type: this.type,
      unit: this.unit,
      value: this.value,
      hidden: this.hidden,
      forced: this.forced,
      ownerId: this.ownerId,
      userId: this.userId,
      publicFlag: this.publicFlag,
      localization: this.localization,
      defaults: this.defaults,
      validation: this.validation,
      unitFamily: this.unitFamily,
    };
  }
}

export default AttributeModel;